module.exports = __webpack_public_path__ + "static/media/1542318697660-1351038696 - Citizen Datasteward.8720751e.jpg";